import { render, staticRenderFns } from "./StructuresDetails.vue?vue&type=template&id=0aca0e94&"
import script from "./StructuresDetails.vue?vue&type=script&lang=tsx&"
export * from "./StructuresDetails.vue?vue&type=script&lang=tsx&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports